import React from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import List from 'core/modules/Partials/List/List';
import MerchantTileListItem from 'core/modules/MerchantTileList/components/MerchantTileListItem/MerchantTileListItem';
import { useGetRelatedStores } from './hooks/useGetRelatedStores';
import { selectRelatedStoresConfig } from './selectors';

import './RelatedStores.scss';

function RelatedStores({ merchantIds, title, pill }) {
  const { allRelatedStoresMerchants, allMerchantsAreLoaded } = useGetRelatedStores(merchantIds);

  const config = useSelector(selectRelatedStoresConfig);
  const { useAddToFavorite } = config;

  if (isEmpty(allRelatedStoresMerchants) || !allMerchantsAreLoaded) {
    return (null);
  }

  return (
    <div className="mn_relatedStores">
      <SectionTitle title={title} pill={pill} />
      <List shouldUseCarousel>
        {allRelatedStoresMerchants.map(merchant => (
          <MerchantTileListItem
            key={merchant.id}
            merchant={merchant}
            useAddToFavorite={useAddToFavorite}
            label="Extra"
          />
        ))}
      </List>
    </div>
  );
}

RelatedStores.defaultProps = {
  title: 'Related stores',
};

export default (props) => <ComponentErrorBoundary><RelatedStores {...props} /></ComponentErrorBoundary>;
